import { Link, useParams } from 'react-router-dom';

import { useArchiveManager } from './manager/useArchiveManager.js';
import ManagerView from './manager/ManagerView.jsx';
import './ManagerPage.css';

export default function ArchiveManagerPage() {
	const { season, managerCode } = useParams();
	const archive = useArchiveManager({ season, managerCode });
	const { data, picks, status, error, navigating, showPoints } = archive;

	return (
		<div className="manager-page">
			<header className="manager-page__intro">
				<p className="manager-page__eyebrow">
					<Link to="/archive">Archive</Link> · {season}
				</p>
				<h1>{status === 'ready' ? data.name : 'Season archive'}</h1>
				<p className="manager-page__lede">
					Final standings, squad and gameweek history for a completed season.
				</p>
			</header>

			{status === 'error' && (
				<div className="notice notice--error" role="alert">
					<strong>Could not load that season.</strong>
					<span>{error}</span>
				</div>
			)}

			{status === 'loading' && (
				<div className="manager-page__loading" role="status">
					<span className="spinner" aria-hidden="true" />
					<span>Loading season…</span>
				</div>
			)}

			{status === 'ready' && (
				<ManagerView
					data={data}
					picks={picks}
					/* The archive payload puts the display shape in `chip_stats`;
					   `chips` there is the raw FPL array. */
					chips={data.chip_stats}
					title={data.name}
					subtitle={[data.season, data.gw ? `Gameweek ${data.gw}` : null]
						.filter(Boolean)
						.join(' · ')}
					navigating={navigating}
					showPoints={showPoints}
					onPrev={() => archive.goToGameweek('prev')}
					onNext={() => archive.goToGameweek('next')}
					canGoPrev={archive.canGoPrev}
					canGoNext={archive.canGoNext}
				/>
			)}
		</div>
	);
}
